define('presentation/common/colorPickerInput/viewModels/colorPickerInputViewModel',[], function() {
    return function() {
        const self = this;

        let _disposables = [];
        let _settings = null;

        const defaultColorValue = '#000000';

        const _initialize = () => {
            if (_settings.value !== undefined) {
                const initialValue = ko.unwrap(_settings.value);
                self.textInputValue(initialValue);
                self.colorInputValue(initialValue);
            }

            const id = _settings.customId || _settings.id;
            if (id !== undefined) {
                self.customId = id;
            }
        };

        self.customId = "";
        self.textInputValue = ko.observable(defaultColorValue);
        self.colorInputValue = ko.observable(defaultColorValue);


        self.onColorInputValueChanged = (newValue) => {
            if (newValue !== self.textInputValue()) {
                self.textInputValue(newValue);
                _settings.value(newValue);
            }
        };

        self.onTextInputValueChanged = (newValue) => {
            // Only update if it's a valid hex color
            if (/^#([0-9a-f]{3}){1,2}$/i.test(newValue) && newValue !== self.colorInputValue()) {
                self.colorInputValue(newValue);
                _settings.value(newValue);
            }
        };

        self.activate = (settings) => {
            _settings = settings;
            _initialize();

            _disposables.push(self.textInputValue.subscribe(self.onTextInputValueChanged));
            _disposables.push(self.colorInputValue.subscribe(self.onColorInputValueChanged));
        };
    };
});

